const validClabeRegex = /^\d{18}$/;

const validClabe = (rfc: string): boolean => validClabeRegex.test(rfc);

export default validClabe;
